import React, {Component} from 'react'
import {connect} from 'react-redux'
import cls from 'classnames'

import Sticker from '../../components/Sticker/Sticker'
import UrlList from '../../components/UrlList/UrlList'
import TextArea from '../../components/TextArea/TextArea'
import SubmitButton from '../../components/Button/Button'
import DeleteButton from '../../components/Button/Button'
import ContentColumn from '../../components/GridColumn/GridColumn'
import SidebarColumn from '../../components/GridColumn/GridColumn'

import {
	saveText,
	saveUrlList,
	deleteDuplicateList
} from '../../store/actions/storage'

import {getUrlListfromString} from '../../utils/utils'
import classes from './Submit.module.scss'

class Submit extends Component {
	saveText = value => {
		this.props.saveText(value)
	}

	saveUrlList = () => {
		this.props.saveUrlList(getUrlListfromString(this.props.text))
		this.props.saveText('')
	}

	deleteDuplicateList = () => {
		this.props.deleteDuplicateList()
	}

	render() {
		return (
			<React.Fragment>
				<div
					className='row'
				>
					<ContentColumn
						size={9}
					>
						<TextArea
							value={this.props.text}
							label='Past text with urls here:'
							saveText={this.saveText}
						/>
					</ContentColumn>
					<SidebarColumn
						size={3}
						alignContent='center'
					>
						<SubmitButton
							label='Submit'
							className={cls('btn-primary', classes['Submit__submit-button'])}
							onClick={this.saveUrlList}
						/>
					</SidebarColumn>
				</div>
				{
					this.props.duplicateUrlList.length
						? <div
							className='row'
						>
							<ContentColumn
								size={9}
								className={classes['Submit__duplicate-list-column']}
							>
								<span
									className={classes['Submit__sub-title']}
								>
									{`List of duplicate urls (${this.props.duplicateUrlList.length}):`}
								</span>
								<UrlList
									urlList={this.props.duplicateUrlList}
									linkClassName={classes['Submit__duplicate-link']}
								/>
							</ContentColumn>
							<SidebarColumn
								size={3}
								alignContent='center'
							>
								<Sticker
									className={classes.Submit__sticker}
								>
									<DeleteButton
										label='Delete all'
										className={cls('btn-danger', classes['Submit__delete-button'])}
										onClick={this.deleteDuplicateList}
									/>
								</Sticker>
							</SidebarColumn>
						</div>
						: null
				}
			</React.Fragment>
		)
	}
}

const mapStateToProps = state => ({
	text: state.storage.text,
	duplicateUrlList: state.storage.duplicateUrlList
})

const mapDispatchToProps = dispatch => ({
	saveText: value => dispatch(saveText(value)),
	saveUrlList: urlList => dispatch(saveUrlList(urlList)),
	deleteDuplicateList: () => dispatch(deleteDuplicateList())
})

export default connect(mapStateToProps, mapDispatchToProps)(Submit)